import {jwtServerInstance} from "../index";
import qs from	'qs'

//查询所有数据字典项
export const getAllStore = () => {
    return jwtServerInstance.request({
        url:'/Storelist/all',
        method:'post'
    })
}

//参数配置列表查询接口
export const getStores = (queryForm, pagination ) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/query',
        method:'post',
        data:qs.stringify({
            userId:queryForm.userid,
            userName:queryForm.userName,
            personName: queryForm.personName,
            backCardNum: queryForm.backCardNum,
            ownerWeb: queryForm.ownerWeb,
            startTime: queryForm.timeRange?queryForm.timeRange[0]:null,
            endTime: queryForm.timeRange?queryForm.timeRange[1]:null,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

//参数配置列表查询接口
export const getBusiness = (queryForm, pagination ) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/querybusiness',
        method:'post',
        data:qs.stringify({
            businessType:queryForm.businessType,
            upBusinessUser: queryForm.upBusinessUser,
            businessName: queryForm.businessName,
            ownerWeb: queryForm.ownerWeb,
            roleCode: queryForm.roleCode,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

//参数配置列表查询接口
export const getStoresDetail = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/querydetail',
        method:'post',
        data:qs.stringify({
            userId:queryForm.userId
        })
    })
}

//更新b2c_goods的一条数据记录
export const updateUserStatus = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/updatebstatus',
        method:'post',
        data:qs.stringify({
            userId:dialogForm.userId,
            status:dialogForm.status
        })
    })
}

//更新b2c_goods的一条数据记录
export const updateUserEnable = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/updatebenable',
        method:'post',
        data:qs.stringify({
            userId:dialogForm.userId,
            usedEnable:dialogForm.usedEnable
        })
    })
}

//更新b2c_goods的一条数据记录
export const updateBusinessOrderEnable = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/updateborenable',
        method:'post',
        data:qs.stringify({
            userId:dialogForm.userId,
            usedEnable:dialogForm.usedEnable
        })
    })
}

//更新b2c_goods的一条数据记录
export const updateStore = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/update',
        method:'post',
        data:dialogForm
    })
}

//新增一条b2c_goods数据记录
export const addStore = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/Storelist/add',
        method:'post',
        data:dialogForm
    })
}

//删除一条b2c_goods数据记录
export const deleteStore = (deleteId) => {
    return jwtServerInstance.request({
        url:'/Storelist/delete',
        method:'post',
        data:qs.stringify({
            id:deleteId
        })
    })
}

//新增一条b2c_goods数据记录
export const addAllShops = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cbusinesssetting/sysadd',
        method:'post',
        data:dialogForm
    })
}

//更新b2c_goods的一条数据记录
export const updateManagerPerson = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cmanagepersons/update',
        method:'post',
        data:dialogForm
    })
}

//新增获取商返信息
export const queryStoreBusinessSetting = (dialogForm, pagination) => {
    return jwtServerInstance.request({
        url:'/b2cbusinesssetting/query',
        method:'post',
        data:qs.stringify({
            id:null,
            bindShops: null,
            discountNumber: null,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}


//参数配置列表查询接口
export const getShopsVo = (queryForm, pagination ) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/queryshops',
        method:'post',
        data:qs.stringify({
            shopName:queryForm.shopName,
            userName:queryForm.userName,
            shopUsername: queryForm.shopUsername,
            shopGroup: queryForm.shopGroup,
            systemGroup: queryForm.systemGroup,
            shopTypeId:queryForm.shopTypeId,
            status: queryForm.status,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

//更新b2c_goods的一条数据记录
export const updateShopStatus = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/updateshopstatus',
        method:'post',
        data:qs.stringify({
            shopId:dialogForm.shopId,
            status:dialogForm.status,
            because: dialogForm.because
        })
    })
}

//新增批量审核店铺
export const updateBatchShopStatus = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/updatebatchshopstatus',
        method:'post',
        data: dialogForm
    })
}

//更新b2c_goods的一条数据记录
export const updateShopSetting = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/updateshopsetting',
        method:'post',
        data:dialogForm
    })
}


//参数配置列表查询接口
export const getShopSetting = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/queryshopset',
        method:'post',
        data:qs.stringify({
            shopId:queryForm.id
        })
    })
}


//更新b2c_goods的一条数据记录
export const setCommission = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/setbusinesslimit',
        method:'post',
        data:dialogForm
    })
}

//更新b2c_goods的一条数据记录
export const setCommissionMoney = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/setbusinessmlimit',
        method:'post',
        data:dialogForm
    })
}
//参数配置列表查询接口
export const getCommission = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/querycomission',
        method:'post',
        data:qs.stringify({
            userId:queryForm.businessId
        })
    })
}

//参数配置列表查询接口
export const getCommissionMoney = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/querycomissionmoney',
        method:'post',
        data:qs.stringify({
            userId:queryForm.businessId
        })
    })
}

//参数配置列表查询接口
export const updateBusinessWebEnable = (queryForm) => {
    return jwtServerInstance.request({
        url:'/b2cbusinessvo/updatewenable',
        method:'post',
        data:qs.stringify({
            userId:queryForm.businessId,
            websitEnable:true
        })
    })
}


